import { defineMessages } from 'react-intl.macro';

import { FormattedMessage } from 'react-intl';

import { BtnBar, CtaBtn, Link, SecondaryBtn } from '@tmapy/style-guide';

import { useAuth, useHistoryAction, useSelector } from '../hooks';
import { PageTitle } from '../app/components/PageTitle';
import { MainContent } from '../app/components/MainContent';

const IPR_DATA_RULES_URL = 'https://geoportalpraha.cz/backend/getdokument/1';
const IPR_GEOPORTAL_URL = 'https://www.geoportalpraha.cz';

const msg = defineMessages({
  title: {
    id: 'vydej.home.title',
    defaultMessage:
      '{customerType, select, ipr {Vítejte v aplikaci eVýdej} other {Vítejte v aplikaci pro výdej geografických dat}}',
  },
  description: {
    id: 'vydej.home.description',
    defaultMessage:
      '{customerType, select, ipr {Aplikační systém výdej dat je webová aplikace určená k online objednávání geografických dat hl. m. Prahy.} other {Aplikační systém výdej dat je webová aplikace určená pro podporu výdeje dat z datového skladu.}}',
  },
  iprDataRules: {
    id: 'vydej.home.ipr.dataRules',
    defaultMessage:
      'Poskytování dat se řídí dokumentem <rulesLink>Pravidla pro poskytování dat a výstupů z datového skladu Geografického informačního systému hl. m. Prahy</rulesLink>, jehož součástí jsou i licenční podmínky.',
  },
  iprMoreInfo: {
    id: 'vydej.home.ipr.moreInfo',
    defaultMessage:
      'Další informace o mapových produktech IPR Praha naleznete na <geoportalLink>www.geoportalpraha.cz</geoportalLink>.',
  },
  new: {
    id: 'vydej.home.newOrder',
    defaultMessage: 'Vytvoření žádosti o data',
  },
  list: {
    id: 'vydej.home.orderList',
    defaultMessage: 'Přehled žádostí o data',
  },
});

export const VydejHome = () => {
  const auth = useAuth();
  const customerType = useSelector((state) => state.app.config.customerType);
  const handleNewOrderBtnClick = useHistoryAction('vydejNewOrder');
  const handleOrderListBtnClick = useHistoryAction('vydejOrderList');

  return (
    <MainContent>
      <div className='sg-u-vs-4'>
        <PageTitle>
          <FormattedMessage {...msg.title} values={{ customerType }} />
        </PageTitle>
        <p>
          <FormattedMessage {...msg.description} values={{ customerType }} />
        </p>
        {customerType === 'ipr' && (
          <>
            <p>
              <FormattedMessage
                {...msg.iprDataRules}
                values={{
                  rulesLink: (chunks) => (
                    <Link href={IPR_DATA_RULES_URL} severity='colorful' target='_blank' isExternal>
                      {chunks}
                    </Link>
                  ),
                }}
              />
            </p>
            <p>
              <FormattedMessage
                {...msg.iprMoreInfo}
                values={{
                  geoportalLink: (chunks) => (
                    <Link href={IPR_GEOPORTAL_URL} severity='colorful' target='_blank' isExternal>
                      {chunks}
                    </Link>
                  ),
                }}
              />
            </p>
          </>
        )}
        <BtnBar align='left'>
          {auth.hasPermission('Orders', 'create', null) && (
            <CtaBtn onClick={handleNewOrderBtnClick}>
              <FormattedMessage {...msg.new} />
            </CtaBtn>
          )}
          <SecondaryBtn onClick={handleOrderListBtnClick}>
            <FormattedMessage {...msg.list} />
          </SecondaryBtn>
        </BtnBar>
      </div>
    </MainContent>
  );
};
